import { render, staticRenderFns } from "./settlementRecords.vue?vue&type=template&id=b35223a0&scoped=true&"
import script from "./settlementRecords.vue?vue&type=script&lang=js&"
export * from "./settlementRecords.vue?vue&type=script&lang=js&"
import style0 from "./settlementRecords.vue?vue&type=style&index=0&id=b35223a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35223a0",
  null
  
)

export default component.exports